import DateInput from "./DateInput";
import FileInput from "./FileInput";
import Input from "./Input";
import InputArea from "./InputArea";

export { DateInput, FileInput, InputArea };
export default Input;
